import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=70143f72&"
import script from "./PopupComponent.vue?vue&type=script&lang=ts&"
export * from "./PopupComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports